module.exports = __webpack_public_path__ + "assets/img/Acme_Logo.c3eadf20.svg";